import { render, staticRenderFns } from "./BarcodeConfiguration.vue?vue&type=template&id=6e1ddc54&scoped=true&"
import script from "./BarcodeConfiguration.vue?vue&type=script&lang=js&"
export * from "./BarcodeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeConfiguration.vue?vue&type=style&index=0&id=6e1ddc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ddc54",
  null
  
)

export default component.exports